import {DataTable} from '../ui/DataTable';
import {StatusBadge} from '../ui/StatusBadge';
import {Link} from '../ui/ScopedLink';
import {withBuildingScope} from '../ui/building-scope';
import {formatDateOnly,formatDateTime} from '../dates';
import type {Action} from './OperationsProgramme';

export function ProgrammeActionRegister({rows,building}:{rows:Action[];building?:string|undefined}){
 return <DataTable caption={<span className="sr-only">Programmes and visits</span>} scrollLabel="Programme work and attendance" rows={rows} getRowKey={row=>row.id} pageSize={18}
 rowHeader={{id:'work',header:'Work',render:row=><Link to={withBuildingScope('/operations/programmes/actions/'+row.id,building)}>{row.title}</Link>}}
 columns={[
  {id:'building',header:'Building',render:row=>row.building_name},
  {id:'due',header:'Due date',sortValue:row=>row.due_on,render:row=>formatDateOnly(row.due_on,'Not recorded')},
  {id:'owner',header:'Owner',render:row=>row.assignee_name??'Unassigned'},
  {id:'attendance',header:'Planned attendance',render:row=>row.starts_at?<><time dateTime={row.starts_at}>{formatDateTime(row.starts_at)}</time>{row.ends_at?<span className="register-secondary">Ends {formatDateTime(row.ends_at)}</span>:<span className="register-secondary">End not recorded</span>}</>:'Not booked'},
  {id:'state',header:'Recorded state',render:row=><StatusBadge text={row.status}/>},
  {id:'report',header:'Checklist evidence',render:row=>row.report_assignment_id?<Link to={withBuildingScope('/reports/'+row.report_assignment_id,building)}>{row.report_status??'Open checklist'}</Link>:row.report_status??'Not assigned'},
 ]}/>;
}
